import { render, staticRenderFns } from "./SignupCommonFrame.vue?vue&type=template&id=81061ec0&scoped=true&"
import script from "./SignupCommonFrame.vue?vue&type=script&lang=js&"
export * from "./SignupCommonFrame.vue?vue&type=script&lang=js&"
import style0 from "./SignupCommonFrame.vue?vue&type=style&index=0&id=81061ec0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81061ec0",
  null
  
)

export default component.exports